export enum PorposalExpectedResult
{
    PATENTE = 1,
    PUBLICACIONREVISTA = 2,
    OTRASPUBLICACIONES = 3,
    OTROS = 4
}